import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { createReferenceEqualSelector } from '../../selectors/utils';
import { matcher } from './helpers';
import type { RootState } from '../../index';

export type StoredError = { message: string; httpCode?: number };

const errorSlice = createSlice({
  name: 'error',
  initialState: {
    errors: [],
  } as { errors: StoredError[] },
  extraReducers: (builder) =>
    builder.addMatcher(
      matcher,
      (
        state,
        action: PayloadAction<
          unknown,
          string,
          unknown,
          { message: string; httpCode?: number }
        >,
      ) => {
        const { error } = action;
        state.errors.push({ message: error.message, httpCode: error.httpCode });
      },
    ),
  reducers: {},
});

export default errorSlice.reducer;

const errorSelector = (state: RootState) => state.error;

export const selectErrors = createReferenceEqualSelector(
  errorSelector,
  (error) => error.errors,
);
export const selectHasErrors = createReferenceEqualSelector(
  selectErrors,
  (errors) => !!errors.length,
);
